/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';

//Third party packages
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import { axiosInstance } from 'src/api/axios';
import APIEndpoints from 'src/Admin/api/APIEndpoints';
import { ResourcesCard } from 'src/Member/components/Resources/ResourcesCard';
import MasterPermissions from 'src/Member/api/MasterPermissions';
import './Resources.scss';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

const Resources = () => {
  const displayViewAll = 10;

  const { t } = useTranslation();
  const user = useSelector((state) => state?.user?.userData || {});

  const [loader, setLoader] = useState(false);
  const [resourcesList, setResourcesList] = useState([]);

  useEffect(() => {
    setLoader(true);

    const getResources = async () => {
      const oidParams = `${'memberoid'}/${user?.MemberDetails?.MemberOID}`;
      const userTypeParams = `membertype/${user?.MemberDetails?.MemberType}`;
      const displayContent = '/DisplayOnDashboard/true';

      return await axiosInstance.get(
        `${APIEndpoints.searchResourceResource()}${displayContent}/${userTypeParams}/${oidParams}`,
      );
    };

    (async () => {
      try {
        const resourceData = await getResources();
        let resourceList = resourceData?.data?.Response?.Resources;
        resourceList = resourceList
          ? resourceList.filter((r) => r.ResourceGroupNumber !== 4)
          : [];
        //const resourcesToDisplay = resourceList.slice( 0, displayViewAll );

        setResourcesList(resourceList);
      } catch (error) {
        console.error(error);
      } finally {
        setLoader(false);
      }
    })();
  }, [user?.MemberDetails?.MemberOID]);

  return (
    <>
      {(MasterPermissions.CheckPermission('View Resources') ||
        MasterPermissions.CheckPermission('View Resource')) &&
      resourcesList?.length > 0 ? (
        <div className="col-md-4 margin-bottom-32">
          <Card className="resource-container">
            <div className="d-flex justify-content-between align-items-center">
              <h3 className="resource-title">
                <span className="sr-only">Details of</span>{' '}
                {t('member.dashboard.resource.resource')}
              </h3>
              <Link
                to="/member/allresources"
                push={true.toString()}
                className="view-all-resources"
              >
                {t('member.dashboard.resource.title')}
              </Link>
            </div>

            <div className="resources">
              <Card.Body
                className={
                  resourcesList.length >= displayViewAll
                    ? 'dashboard-data-space-view-resources'
                    : 'dashboard-data-space-resources'
                }
              >
                <ResourcesCard data={resourcesList} showDescription={false} />
              </Card.Body>
            </div>
          </Card>
        </div>
      ) : null}

      {/*{loader && (
        <Loader
          active
          size='large'
          className='font-weight-bold loader-color'
        >
          Loading Resources...
        </Loader>
      )} */}
    </>
  );
};

export default Resources;
